<div style="height: 95%;">

    <app-edit-table [data]="sampleDataForDataStore"></app-edit-table>
</div>